import {useEffect, useState} from "react";

const FlyingToLocation = ({onLocationChange, initSearchValue = ""}) => {
    const [searchValue, setSearchValue] = useState(initSearchValue);
    const [selectedItem, setSelectedItem] = useState(null);
    const [locationSearchContent, setLocationSearchContent] = useState([]);
    const [allLocations, setAllLocations] = useState([]);

    useEffect(() => {
        fetch('https://api.tripsi.pl/api/destinations') // replace 'API_URL' with the actual API endpoint
            .then(response => response.json())
            .then(data => {
                let countries = data.map((item) => {
                    return item.country;
                });
                let uniqueCountries = [...new Set(countries)];
                let uniqueDestinations = [];

                for (let country of uniqueCountries) {
                    uniqueDestinations.push({
                        "name": country,
                        "country": "Państwo"
                    })
                }
                data.map((item) => {
                    uniqueDestinations.push({
                        "name": item.name,
                        "country": item.country
                    })
                });
                uniqueDestinations.reverse();
                setLocationSearchContent(uniqueDestinations)
                setAllLocations(uniqueDestinations)
            })
            .catch(error => console.error('Error:', error));
    }, []);


    const handleOptionClick = (item) => {
        setSearchValue(item.name);
        setSelectedItem(item.name);
        onLocationChange(item.name);
    };

    function filterDestinations(value) {
        setSearchValue(value);
        onLocationChange(value);
        const filteredDestinations = allLocations.filter((item) => {
            return item.name.toLowerCase().includes(value.toLowerCase());
        });
        setLocationSearchContent(filteredDestinations);
        // setSearchValue(value);
    }

    return (
        <>
            <div className="searchMenu-loc px-24 lg:py-20 lg:px-0 js-form-dd js-liverSearch">
                <div
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="true"
                    data-bs-offset="0,22"
                >
                    <h4 className="text-15 fw-500 ls-2 lh-16">Podróż do</h4>
                    <div className="text-15 text-light-1 ls-2 lh-16">
                        <input
                            autoComplete="off"
                            type="search"
                            placeholder="Gdziekolwiek"
                            aria-label="Podróż do"
                            className="js-search js-dd-focus"
                            value={searchValue}
                            id="destination-search"
                            onChange={(e) => filterDestinations(e.target.value)}
                        />
                    </div>
                </div>

                <div className="shadow-2 dropdown-menu min-width-400">
                    <div className="bg-white px-20 py-20 sm:px-0 sm:py-15 rounded-4">
                        <ul className="y-gap-5 js-results">
                            {locationSearchContent.map((item) => (
                                <li
                                    className={`-link d-block col-12 text-left rounded-4 px-20 py-15 js-search-option mb-1 ${
                                        selectedItem && selectedItem.id === item.id ? "active" : ""
                                    }`}
                                    key={item.id}
                                    role="button"
                                    onClick={() => handleOptionClick(item)}
                                >
                                    <div className="d-flex">
                                        <div className="icon-location-2 text-light-1 text-20 pt-4"/>
                                        <div className="ml-10">
                                            <div className="text-15 lh-12 fw-500 js-search-option-target">
                                                {item.name}
                                            </div>
                                            <div className="text-14 lh-12 text-light-1 mt-5">
                                                {item.country}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FlyingToLocation;
